export default function SectionCard({ title, children }) {
  return (
    <div className="bg-white shadow-md rounded-xl p-6 mb-6 dark:bg-gray-800">
      <h3 className="text-lg font-semibold mb-4">{title}</h3>
      {children}
    </div>
  );
}
